import Api from '@/services/Index';

const register = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/register', config);
}
const verifyRegister = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/verify-register', formData);
}
const login= async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/login',formData);
}
const verifyLogin = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/verify-login',formData);
}
const programs = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/ulmer-application/available-certificate-list');
}
const savePersonalInformation = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/update-personal-information',formData);
}
const myApplicationList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/my-application-list',formData);
}
const makeApplication = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/ulmer-application/make-application',formData);
}



export default {
    register,
    programs,
    login,
    verifyRegister,
    verifyLogin,
    savePersonalInformation,
    myApplicationList,
    makeApplication
}
